import { useEffect, useRef, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import withLoader from "../../components/layouts/WithLoader";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import QrCodeModal from "../../ui/QrCodeModal";

const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
const labelStyle = {
  fontSize: "0.8rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.03em",
  color: "#6c757d",
};

const ScannerProduit = ({ startLoading, stopLoading }) => {
  const animatedComponents = makeAnimated();
  const [allWarehouses, setAllWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseOption, setWarehouseOption] = useState(null);
  const [productstock, setProductstock] = useState();
  const [searched, setSearched] = useState(false);
  const [lastBarcode, setLastBarcode] = useState("");

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [barcode, setBarcode] = useState("");
  const [showModal, setShowModal] = useState(false);
  const barcodeInputRef = useRef(null);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          setAllWarehouses(
            response.data.success.map((element) => ({
              value: element.id,
              label: element.name,
            }))
          );
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const onChangeSelectedWarehouse = (selectedOptionn) => {
    setWarehouseOption(selectedOptionn);
    setWarehouseId(selectedOptionn.value);
    setProductstock(undefined);
    setSearched(false);
    if (barcodeInputRef.current) barcodeInputRef.current.focus();
  };

  const canSearch = warehouseId !== 0 && barcode.trim() !== "";

  const getProductInfos = () => {
    if (!canSearch) return;
    const scanned = barcode.trim();
    setLastBarcode(scanned);
    startLoading();
    WarehouseService.checkStockByProductQteAndProductPrice(
      getCurrentUserId(),
      scanned,
      warehouseId
    )
      .then((response) => {
        setProductstock(response?.data?.success || undefined);
        setSearched(true);
      })
      .catch((error) => {
        setProductstock(undefined);
        setSearched(false);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
        // prêt pour le scan suivant
        setBarcode("");
        if (barcodeInputRef.current) barcodeInputRef.current.focus();
      });
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenErrorAlert(false);
  };

  const qte = productstock ? Number(productstock.qte) : null;
  const inStock = qte !== null && qte > 0;

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <h4 className="mb-1">
            <i className="fas fa-barcode mr-2"></i>Scanner un produit
          </h4>
          <small className="text-muted">
            Choisissez un dépôt puis scannez le code à barre pour voir le prix et
            le stock
          </small>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark mt-3" style={cardStyle}>
            <div className="card-body">
              <div className="row">
                <div className="col-md-5">
                  <div className="form-group">
                    <label style={labelStyle}>Dépôt</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      value={warehouseOption}
                      onChange={onChangeSelectedWarehouse}
                      options={allWarehouses}
                      placeholder="Choisir un dépôt..."
                    />
                  </div>
                </div>
                <div className="col-md-7">
                  <div className="form-group">
                    <label htmlFor="scannerBarcode" style={labelStyle}>
                      Code à barre
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text bg-white">
                          <i className="fas fa-barcode"></i>
                        </span>
                      </div>
                      <input
                        id="scannerBarcode"
                        ref={barcodeInputRef}
                        type="text"
                        className="form-control"
                        placeholder="Scannez ou saisissez le code à barre"
                        value={barcode}
                        onChange={(e) => setBarcode(e.target.value)}
                        onKeyDown={(e) => e.key === "Enter" && getProductInfos()}
                        autoFocus
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-dark px-4"
                          onClick={getProductInfos}
                          disabled={!canSearch}
                        >
                          Rechercher
                        </button>
                      </div>
                    </div>
                    <small className="text-muted">
                      {warehouseId === 0
                        ? "Choisissez d'abord un dépôt."
                        : "Un lecteur de codes à barre valide automatiquement avec Entrée."}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {productstock && productstock.product && (
            <div className="card card-outline card-dark" style={cardStyle}>
              <div className="card-header">
                <h3 className="card-title">
                  <i className="fas fa-box mr-2"></i>Le produit
                </h3>
              </div>
              <div className="card-body">
                <div className="row align-items-center">
                  <div className="col-lg-5 mb-3 mb-lg-0">
                    <small className="text-muted text-uppercase d-block" style={{ fontWeight: 600 }}>
                      Libellé
                    </small>
                    <h4 className="mb-1">{productstock.product.name}</h4>
                    <span className="badge badge-light border">
                      <i className="fas fa-barcode mr-1"></i>
                      {productstock.product.barcode}
                    </span>
                  </div>
                  <div className="col-6 col-lg-2">
                    <small className="text-muted text-uppercase d-block" style={{ fontWeight: 600 }}>
                      Prix de vente
                    </small>
                    <span style={{ fontSize: "1.5rem", fontWeight: 700 }}>
                      {productstock.initial_selling_price}
                    </span>
                  </div>
                  <div className="col-6 col-lg-2">
                    <small className="text-muted text-uppercase d-block" style={{ fontWeight: 600 }}>
                      Quantité
                    </small>
                    <span
                      className={`badge ${inStock ? "badge-success" : "badge-danger"}`}
                      style={{ fontSize: "1.1rem" }}
                    >
                      {productstock.qte}
                    </span>
                    <small className="d-block text-muted">
                      {inStock ? "En stock" : "Rupture de stock"}
                    </small>
                  </div>
                  <div className="col-lg-3 text-lg-right mt-3 mt-lg-0">
                    <button className="btn btn-outline-dark" onClick={openModal}>
                      <i className="fas fa-qrcode mr-1"></i>
                      Imprimer le QR code
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {searched && !productstock && (
            <div className="text-center text-muted py-5">
              <i className="fas fa-box-open fa-2x mb-2 d-block"></i>
              Aucun produit trouvé pour «&nbsp;{lastBarcode}&nbsp;» dans ce dépôt
            </div>
          )}
        </div>
      </section>

      <QrCodeModal isOpen={showModal} onClose={closeModal} row={productstock} />

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={3000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ScannerProduit);
